import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VehicleTypesComponent } from './manage-vehicle-type.component';

const routes: Routes = [
  { path: '', component: VehicleTypesComponent, data: { title: 'Manage Vehicle Types' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageVehicleTypeRoutingModule {}

@NgModule({
  imports: [
    ManageVehicleTypeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [VehicleTypesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageVehicleTypeModule {}
